import { LeadsType } from "app/pages/sales-intelligence/sub-modules/company-search/types/common";
import createCRMLeadsSelectionDropdown from "app/pages/sales-intelligence/sub-modules/management/models/websites-crm-export/factory";

const CrmExportSelectionDropdown = createCRMLeadsSelectionDropdown(LeadsType.Websites);

export default CrmExportSelectionDropdown;
